// email addresses start with a string of letters, numbers, and/or ._%+- followed by an @, followed by a string of letters, numbers or dashes, followed by a dot, followed by letters 2-unlimited characters long, case insensitive
export const emailRegex = new RegExp(
  /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,}$/i
)

export const isValidEmail = (email: string) => emailRegex.test(email)